import { FC } from 'react'

import { Card } from 'ui'
import { t } from 'translations'

type Props = {
  triggerSearch: () => void
}

const FiltersChange: FC<Props> = ({ triggerSearch }) => {
  return (
    <Card className="d-flex flex-column justify-content-center align-items-center h-100 bg-light">
      <i className="fa-duotone fa-arrows-rotate fa-4x mb-3"></i>
      <div className=" h5 mb-2">{t('components.filtersChange.FILTERS_HAVE_CHANGED')}</div>
      <small onClick={() => triggerSearch()} className="text-link text-primary">
        {' '}
        {t('components.filtersChange.SEARCH_LINK')}
      </small>{' '}
    </Card>
  )
}

export default FiltersChange
